(function ($) {
    const selectClass = '.js-select2';
    let args = {
        width: '100%',
        height: 'resolve',
        minimumResultsForSearch: -1,
        containerCssClass: 'product-card-select',
        dropdownCssClass: 'product-card-select-dropdown',
        selectionCssClass: 'product-card-select-selection',
    };
    $(selectClass).select2(args);
})(jQuery);
